module.exports = __webpack_public_path__ + "front/img/d9.77ba33f2.png";